export default function Numpy_Syllabus() {
  return <div>Numpy_Syllabus Component</div>;
}
